import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Reset scroll to the top on every route change — the app scrolls on `window`
 * (marketing/home/player/auth pages have no inner scroll container), so a plain
 * `window.scrollTo(0, 0)` lands the new page at the top instead of inheriting
 * the previous page's offset. Skipped when the URL carries a `#hash` so we don't
 * fight in-page anchor jumps (e.g. the Guides jump-nav).
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0)
  }, [pathname, hash])
  return null
}
